import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/engagement',
    name: 'engagement',
    component: () => import(/* webpackChunkName: "engagement" */ '../views/EngagementView.vue')
  },
  {
    path: '/wedding',
    name: 'wedding',
    component: () => import(/* webpackChunkName: "wedding" */ '../views/WeddingView.vue')
  },
  {
    path: '/olly',
    name: 'olly',
    component: () => import(/* webpackChunkName: "olly" */ '../views/OllyView.vue')
  },
  {
    path: '/olly/new-born',
    name: 'new-born',
    component: () => import(/* webpackChunkName: "new-born" */ '../views/olly/NewBornView.vue')
  },
  {
    path: '/olly/one-year-old',
    name: 'one-year-old',
    component: () => import(/* webpackChunkName: "one-year-old" */ '../views/olly/OneYearOldView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  // Add the scrollBehavior method here
  scrollBehavior(to, from, savedPosition) {
    // If a saved position is available (like using back/forward browser buttons), use it
    if (savedPosition) {
      return savedPosition
    } else {
      // Otherwise, always scroll to the top
      return { top: 0, left: 0 }
    }
  },
})

export default router
